import { render, staticRenderFns } from "./EditPersonalBizumPaymentConfig.vue?vue&type=template&id=2b3c0768&scoped=true&"
import script from "./EditPersonalBizumPaymentConfig.vue?vue&type=script&lang=ts&"
export * from "./EditPersonalBizumPaymentConfig.vue?vue&type=script&lang=ts&"
import style0 from "./EditPersonalBizumPaymentConfig.vue?vue&type=style&index=0&id=2b3c0768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c0768",
  null
  
)

export default component.exports